import { GameId, ProductV2 } from '@common'

import { useTranslatable } from '@/localization/useTranslatable'

import { useProductImage } from '../card/utils'
import { AnimatedImageWithFallback } from '../imageWithFallback/AnimatedImageWithFallback'
import { ImageWithFallback } from '../imageWithFallback/ImageWithFallback'

interface Props {
  game: GameId
  item: ProductV2['contents'][number]
}

export const ProductItemImage = ({ game, item }: Props) => {
  const translatable = useTranslatable()
  const { imageSrc, isAnimated, animatedSrc, safariAnimatedSrc } = useProductImage({
    game: game,
    productId: item.product.id,
  })

  const title = translatable(item.product.title)

  return isAnimated ? (
    <AnimatedImageWithFallback
      animationSrc={animatedSrc}
      fallbackImage={imageSrc}
      safariAnimationSrc={safariAnimatedSrc}
    />
  ) : (
    <ImageWithFallback productImage={imageSrc} title={title} />
  )
}
